import { get } from 'lodash';
import i18next from 'i18next';

import normalizeStringValue from '@commons/utils/normalizeStringValue';

const getSheetConfiguration = () => ({
  STORE_SUPPLIER_PROFILE_MAPPING: {
    id: 'storeSupplierProfileMappings',
    name: i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.SHEET_NAME'),
  },
});

const getNormalizedColumnIds = () => ({
  ID: { key: 'id', normalizedKey: 'id' },
  STORE_NAME: {
    key: 'storeName',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.NAME'),
    ),
  },
  SUPPLIER_PROFILE_NAME: {
    key: 'supplierProfileName',
    normalizedKey: normalizeStringValue(
      i18next.t(
        '_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.SUPPLIER_PROFILE_NAME',
      ),
    ),
  },
  STORE_CITY: {
    key: 'storeCity',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.STORE_CITY'),
    ),
  },
  STORE_COUNTRY: {
    key: 'storeCountry',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.STORE_COUNTRY'),
    ),
  },
  CUSTOMER_CODE: {
    key: 'customerCode',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.CUSTOMER_CODE'),
    ),
    mappingFn: (row, normalizedKey) => get(row, normalizedKey, null),
  },
  WAREHOUSE_CODE: {
    key: 'warehouseCode',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.STORE_SUPPLIER_PROFILE_MAPPINGS.IMPORTS.WAREHOUSE_CODE'),
    ),
    mappingFn: (row, normalizedKey) => get(row, normalizedKey, null),
  },
});

export default {
  getSheetConfiguration,
  getNormalizedColumnIds,
};
